import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { baseUrl, localUrl } from "../../config/baseUrl";
import Pagination from "../Pagination/Pagination";

export default function ReportUsersList() {
  const [reports, setReports] = useState([]);

  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 0,
    totalPages: 0,
    totalItems: 0,
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(3);

  useEffect(() => {
    fetchReport();
  }, [pageNumber]);

  const fetchReport = async () => {
    try {
      const res = await axios.get(
        // `${localUrl}/admin/report/users/list?page=${pageNumber}`,
        `${baseUrl}/admin/report/users/list?page=${pageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res?.data.status) {
        setReports(res?.data.data || []);
        const pagination = res?.data.pagination || {};

        setPaginationDetails({
          currentPage: pagination.currentPage,
          totalPages: pagination.totalPages,
          totalItems: pagination.totalRecords,
        });
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          // `${localUrl}/admin/report/delete/${id}`, {
          `${baseUrl}/admin/report/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        fetchReport();
        Swal.fire("Deleted!", "Report has been removed.", "success");
      } catch (error) {
        console.error("Error deleting report:", error);
        Swal.fire("Error!", "Report could not be removed.", "error");
      }
    }
  };

  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-6">
          <div className="dashboard-title">
            <h4 className="dash-head">
              <i className="fa fa-chart-bar me-2" />
              Report List
            </h4>
          </div>
          <div className="custom-bredcump">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Report List
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="cards bus-list">
            <div className="bus-filter">
              <div className="row">
                <div className="col-lg-6">
                  <h5 className="card-title">Report List ({paginationDetails.totalItems || 0})</h5>
                </div>
              </div>
            </div>

            <div className="table table-responsive custom-table">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Message</th>
                    <th>User Id</th>
                    <th>Reported Id</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((item, i) => (
                    <tr key={item.id}>
                      <td>{i + 1}</td>
                      <td>{item.name || "N/A"}</td>
                      <td>{item.title || "N/A"}</td>
                      <td>
                        {item.message
                          ? item.message.slice(0, 50) +
                            (item.message.length > 50 ? "..." : "")
                          : "N/A"}
                      </td>
                      <td>{item.user_id || "N/A"}</td>
                      <td>{item.reported_user_id || "N/A"}</td>
                      <td>{item.created_at}</td>
                      {/* <td>{moment(item.created_at).format("MMM DD, YYYY")}</td> */}
                      <td>
                        <div className="action-buttons">
                          <Link
                            to={`/report/view/${item?.id}`}
                            className="action-btn edit-btn"
                          >
                            <i className="fa fa-eye"></i>
                            <span className="tooltip-text">View</span>
                          </Link>
                          <button
                            title="Delete"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {reports.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No reports found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {totalPages > 1 && (
                <Pagination
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageLimit={pageLimit}
                  paginationDetails={paginationDetails}
                  totalPages={paginationDetails.totalPages}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
